(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/ticker/views/promo.js') >= 0) return;  svs.modules.push('/widgets/ticker/views/promo.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.ticker=_svs.widget.ticker||{};
_svs.widget.ticker.templates=_svs.widget.ticker.templates||{};
svs.widget.ticker.templates.promo = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"ticker-item\">\n  <span class=\"ticker-item__game-name\">\n    "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"promoText") || (depth0 != null ? lookupProperty(depth0,"promoText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"promoText","hash":{},"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":3,"column":17}}}) : helper)))
    + "\n  </span>\n</div>\n";
},"useData":true});
Handlebars.partials['widget-ticker-promo'] = svs.widget.ticker.templates.promo;
})(svs, Handlebars);


 })(window);